import * as types from "./mutationTypes";

export default {
  [types.SET_METADATAS](state, metadatas) {
    state.metadatas = metadatas;
  },
  [types.CLEAR_METADATAS](state) {
    state.metadatas = null;
  },
  [types.SET_TOTAL_METADATAS](state, total) {
    state.totalMetadatas = total;
  },
  [types.CLEAR_TOTAL_METADATAS](state) {
    state.totalMetadatas = null;
  },
  [types.SET_METADATA](state, metadata) {
    state.metadata = metadata;
  },
  [types.CLEAR_METADATA](state) {
    state.metadata = null;
  },
  [types.SET_METADATA_FIELD](state, { field, value }) {
    if (state.metadata) {
      state.metadata[field] = value;
    }
  }
};
